export const COLUMN = 'COLUMN';
export const ROW = 'ROW';